<!--
 * @Author: LiuMeiYu
 * @Date: 2023-01-04 09:24:29
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-05-24 14:12:11
 * @FilePath: \nivara\src\components\HeaderView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="header-container">
    <div class="header-content">
      <div class="header-logo">
        <router-link to="/home">
          CardSwap
        </router-link>
      </div>
      <div class="header-menu">
        <div class="header-menu-item">
          <el-dropdown class="header-dropdown" trigger="click">
            <span class="el-dropdown-link">
              {{ headerTitle
              }}<el-icon class="el-icon--right"><arrow-down /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="$router.push({ path: '/demandList' })"
                  >All Offers</el-dropdown-item
                >
                <el-dropdown-item @click="$router.push({ path: '/orderList' })"
                  >Order</el-dropdown-item
                >
                <el-dropdown-item @click="$router.push({ path: '/chat' })"
                  >Chat</el-dropdown-item
                >
                <el-dropdown-item @click="$router.push({ path: '/account' })"
                  >Account</el-dropdown-item
                >
                <el-dropdown-item @click="$router.push({ path: '/set' })"
                  >Setting</el-dropdown-item
                >
                <el-dropdown-item @click="$router.push({ path: '/wallet' })"
                  >Wallet</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
      <div class="header-avatar-msg" v-if="isLogin">
        <div class="header-avatar-info">
          <el-dropdown>
            <el-image
              class="header-avatar"
              :src="
                userInfo.avatar ||
                  require('../assets/images/default_avatar.png')
              "
            />
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="logout">log out</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <div class="header-userinfo">
            <router-link to="/account">
              <div class="header-userinfo-name">
                {{ userInfo.nickname }}
              </div>
            </router-link>
            <div class="header-userinfo-amount">
              {{ userBalance.withdraw_amount }}
              {{ userBalance.currency_name }}
            </div>
          </div>
        </div>
        <el-badge
          class="header-msg"
          :value="unreadMsgTotal"
          :max="99"
          type="danger"
          :hidden="!unreadMsgTotal"
        >
          <router-link to="/chat">
            <el-icon :size="40"><ChatRound /></el-icon>
          </router-link>
        </el-badge>
      </div>
      <div class="header-login" v-else>
        <router-link to="/login">
          <div class="header-btn-login">Log in</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "@vue/runtime-core";
import { getUserInfoApi, getUserBalanceApi } from "../api/index";
import { getChatListApi } from "../api/chat";
import bus from "../utils/eventBus";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "HeaderView",
  setup() {
    onMounted(() => {
      initHeader();
      bus.on("refreshedMessagesNumber", () => {
        console.log("refreshedMessagesNumber");
        getChatUnreadMsgNumber();
      });
      bus.on("withdrawSuccess", () => {
        getUserBalance();
      });
      bus.on("updateUserInfoSuccess", () => {
        getUserInfo();
      });
      bus.on("changeTitle", (title) => {
        headerTitle.value = title;
      });
    });
    const router = useRouter();
    const state = reactive({
      userInfo: {},
      userBalance: {},
    });
    const headerTitle = ref("Home");
    const isLogin = ref(false);
    const unreadMsgTotal = ref(0);
    // 初始化头部
    const initHeader = () => {
      if (localStorage.getItem("token")) {
        nextTick(() => {
          // 如果缓存有用户信息就直接拿 不再调用接口
          if (localStorage.getItem("userInfo")) {
            let userInfo = localStorage.getItem("userInfo");
            state.userInfo = JSON.parse(userInfo);
          } else {
            getUserInfo();
          }
          getUserBalance();
          getChatUnreadMsgNumber();
          isLogin.value = true;
        });
      } else {
        isLogin.value = false;
      }
    };
    const logout = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("country_id");
      localStorage.removeItem("currency_name");
      localStorage.removeItem("userId");
      localStorage.removeItem("userInfo");
      nextTick(() => {
        router.push({
          path: "/login",
        });
      });
    };
    // 获取消息未读数量
    const getChatUnreadMsgNumber = () => {
      unreadMsgTotal.value = 0;
      let data = {
        token: localStorage.getItem("token"),
      };
      // 获取聊天列表遍历未读消息数量 相加起来
      getChatListApi(data).then((res) => {
        console.log("getChatListApi：", res);
        if (res.data.length) {
          res.data.forEach((element) => {
            unreadMsgTotal.value += element.unread_num;
          });
        }
      });
    };
    // 获取消息未读数量
    const getUserBalance = () => {
      let data = {
        token: localStorage.getItem("token"),
      };
      // 获取聊天列表遍历未读消息数量 相加起来
      getUserBalanceApi(data).then((res) => {
        console.log("getUserBalanceApi：", res);
        if (res.data.data) {
          state.userBalance = res.data.data;
        }
      });
    };
    // 获取基本信息
    const getUserInfo = () => {
      let data = {
        token: localStorage.getItem("token"),
      };
      getUserInfoApi(data).then((res) => {
        console.log("getUserInfoApi：", res);
        if (res.data.data) {
          localStorage.setItem("userInfo", JSON.stringify(res.data.data));
          state.userInfo = res.data.data;
        }
      });
    };
    return { headerTitle, isLogin, unreadMsgTotal, logout, ...toRefs(state) };
  },
});
</script>

<style lang="less" scoped>
.header-container {
  position: relative;
  height: 80px;
  box-shadow: 0 0 10px rgba(45, 67, 191, 0.5);
  .header-content {
    height: 100%;
    margin: 0 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-logo {
      font-size: 20px;
      font-weight: bold;
      a {
        color: #2d43bf;
      }
    }
    .header-menu {
      .header-menu-item {
        .el-dropdown-link {
          cursor: pointer;
          display: flex;
          align-items: center;
          color: #2d43bf;
        }
      }
    }
    .header-login {
      display: flex;
      align-items: center;
      .header-btn-login {
        padding: 10px 25px;
        border-radius: 10px;
        background-color: #03004d;
        cursor: pointer;
      }
      a {
        color: #ffffff;
      }
    }
    .header-avatar-msg {
      display: flex;
      align-items: center;
      .header-avatar-info {
        display: flex;
        align-items: center;
        .header-avatar {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          cursor: pointer;
        }
        .header-userinfo {
          display: flex;
          flex-direction: column;
          color: #2d43bf;
          a {
            color: #2d43bf;
          }

          .header-userinfo-amount {
            color: #fdbc2a;
          }
        }
      }
      .header-msg {
        margin-left: 20px;
        a {
          color: #2d43bf;
        }
      }
    }
  }
}
</style>
